import {register} from '@shopify/theme-sections';
import Dialog from 'a11y-dialog-component';

register('recipe-template', {
  onLoad() {
    /**
     * Initialise the recipe tabs
     */
    const recipeTabs = document.querySelector('.recipe__tabs');
    if (recipeTabs) {
      recipeTabs.addEventListener('click', this.onClickRecipeTabs);
    }

    /**
     * Initialise recipe machine warning modal
     */
    const machineWarningSelector = '.modal--machine-warning';
    const machineWarningElement = this.container.querySelector(machineWarningSelector);
    if (machineWarningElement) {
      this.initialiseRecipeWarning(machineWarningSelector);
    }
  },

  /**
   * Handle initialising recipe machine warning modal
   */
  initialiseRecipeWarning(machineWarningSelector) {
    /**
     * Check sessionStorage for machineWarningDoNotShow value
     */
    const doNotShowWarning = sessionStorage.getItem('machineWarningDoNotShow') === 'true';
    if (doNotShowWarning) {
      return;
    }

    /**
     * Initialise do not show checkbox
     */
    const machineWarningDoNotShow = this.container.querySelector('#warning-overlay__do-not-show');
    if (machineWarningDoNotShow) {
      machineWarningDoNotShow.addEventListener('change', e => {
        sessionStorage.setItem('machineWarningDoNotShow', e.target.checked);
      });
    }

    /**
     * Initialise modal
     */
    const machineWarningModal = new Dialog(machineWarningSelector, {
      openingSelector: '.modal-machine-warning-open',
      closingSelector: '.modal-machine-warning-close',
      backdropSelector: '.overlay--machine-warning',
      onOpen: function() {
        document.body.classList.add('modal--open');
      },
      onClose: function() {
        document.body.classList.remove('modal--open');
      },
    });

    /**
     * Open modal
     */
    machineWarningModal.open();
  },

  /**
   * Handle recipe tab clicks
   */
  onClickRecipeTabs(event) {
    const tabs = event.currentTarget;
    const tab = event.target.closest('.recipe__tab');
    if (!tab) {
      return;
    }
    const tabPanel = tabs.querySelector(`#${tab.getAttribute('aria-controls')}`);
    if (!tabPanel) {
      return;
    }

    // Remove all active tab classes
    const allTabs = tabs.querySelectorAll('.recipe__tab');
    allTabs.forEach(tab => {
      tab.classList.remove('active');
      tab.removeAttribute('aria-selected');
    });
    const allTabPanels = tabs.querySelectorAll('.recipe__tab-content');
    allTabPanels.forEach(tabPanel => {
      tabPanel.classList.remove('active');
    });

    // Set clicked tab to active
    tab.classList.add('active');
    tab.setAttribute('aria-selected', 'true');
    tabPanel.classList.add('active');
  },
});
